import Image from "next/image";
import styles from "./ProfilePopUp.module.scss";
import { useRouter } from "next/router";
import AppContext from "../../../services/app-context-services";
import { useContext, useEffect, useState } from "react";
import Edit from "../../../../shared-assets/Svg/Edit.svg";
import Wifi from "../../../../shared-assets/Svg/Wifi.svg";
import Bookmark from "../../../../shared-assets/Svg/Bookmark.svg";
import DownloadApp from "../../../../shared-assets/Svg/DownloadApp.svg";
import Lock from "../../../../shared-assets/Svg/Lock.svg";
import Monitor from "../../../../shared-assets/Svg/Monitor.svg";
import BuySubscription from "../../../../shared-assets/Svg/BuySubscription.svg";
import HistoryPayment from "../../../../shared-assets/Svg/HistoryPayment.svg";
import LogOut from "../../../../shared-assets/Svg/LogOut.svg";
import Link from "next/link";
import { ROUTES } from "../../../services/router-services";
import { trackEvent } from "../../../services/ga-services";
import Progressbar from "../../../components/progressbar/progressbar";
import { _ } from "../../../services/text-services";
import { API } from "../../../services/api-services";
import AppExitProfile from "../exit-profile/exit-profile.component";
import { ToPersianNumber } from "../helper/helper";

export const ProfilePopUp = () => {
  const appCtx = useContext(AppContext);
  const { isLoggedIn, profile } = appCtx;
  const router = useRouter();

  const m_ms = 30 * 24 * 60 * 60 * 1000;
  const d_ms = 24 * 60 * 60 * 1000;
  const [subInfo, setSubInfo] = useState({ current: 0, total: 0 });
  const [text, setText] = useState("");
  const [showExitPopup, setShowExitPopup] = useState(false);
  const calculateSub = (time: number) => {
    const months = Math.floor(time / m_ms);
    const days = Math.floor((time % m_ms) / d_ms);
    return time >= d_ms
      ? (months ? months + " ماه " : "") +
          (months && days ? " و " : "") +
          (days ? days + " روز " : "")
      : time > 0
      ? "۱ روز "
      : "";
  };

  useEffect(() => {
    if (profile?.active_subs?.length && profile.active_subs.length > 0) {
      let currentmSec = 0;
      let totalmSec = 0;
      for (let i = 0; i < profile.active_subs.length; i++) {
        const sub = profile.active_subs[i];
        const expireTime = new Date(sub.expire_time).getTime();
        const serverTime = new Date(sub.server_time).getTime();
        if (sub.expire_time) {
          const dateAdded = new Date(sub.date_added).getTime();
          currentmSec +=
            expireTime - (dateAdded - serverTime > 0 ? dateAdded : serverTime);
          totalmSec += expireTime - dateAdded;
        }
      }
      setSubInfo({ current: currentmSec, total: totalmSec });
      setText(calculateSub(currentmSec));
    }
  }, [profile?.active_subs]);
  return (
    <div className={styles.popUpWrapper}>
      <div
        className={styles.profileEdit}
        onClick={() => {
          trackEvent("Profile", "Edit Profile");
          router.push(ROUTES.editProfile);
        }}
      >
        <div className={styles.avatarWrapper}>
          <Image src={profile?.avatar} alt="avatar" width={66} height={66} layout="fill" />
        </div>
        <div className={styles.userInfoWrapper}>
          <div className={styles.name}>
            <div>{profile?.nickname ? profile?.nickname : profile?.email}</div>
          </div>
          <span className={styles.mobile}>
            {profile?.mobile
              ? ToPersianNumber(profile?.mobile)
              : profile?.email}
          </span>
          <div className={styles.editProfileIcon}>
            <span>
              <Edit />
            </span>
            ویرایش پروفایل
          </div>
        </div>
      </div>
      {text && (
        <div className={styles.profileSubscribe}>
          {/* <span>اینترنت مصرفی: ایرانسل (تمام‌بها)</span> */}
          <h4>{_(text)} از اشتراکت مونده</h4>
          <Progressbar
            currentValue={subInfo.current}
            totalValue={subInfo.total}
          />
        </div>
      )}

      <div className={styles.profileList}>
        <div className={styles.listItem}>
          <Link href={ROUTES.subscription} prefetch={false}>
            <a
              className={styles.link}
              onClick={() => {}}
            >
              <div className={styles.linkTitle}>
                <span>
                  <BuySubscription />
                </span>
                خرید اشتراک
              </div>

              <div className={styles.linkDescription}>اینترنت نیم‌بها</div>
            </a>
          </Link>
        </div>
        {/* <div className={styles.listItem}>
          <Link href={ROUTES.subscriptions} prefetch={false}>
            <a
              className={styles.link}
              onClick={() => //console.log("before change")}
            >
              <div className={styles.linkTitle}>
                <span>
                  <HistoryPayment />
                </span>
                تاریخچه پرداخت‌ها
              </div>
            </a>
          </Link>
        </div> */}
        <div className={styles.listItem}>
          <Link href={ROUTES.myBests} prefetch={false}>
            <a
              className={styles.link}
              onClick={() => {}}
            >
              <div className={styles.linkTitle}>
                <span>
                  <Bookmark />
                </span>
                لیست‌های من
              </div>
            </a>
          </Link>
        </div>
        <div className={styles.listItem}>
          <Link href={ROUTES.parental_control} prefetch={false}>
            <a
              className={styles.link}
              onClick={() => {}}
            >
              <div className={styles.linkTitle}>
                <span>
                  <Lock />
                </span>
                کنترل والدین
              </div>
            </a>
          </Link>
        </div>
        {/* <div className={styles.listItem}>
          <Link href={API.tv_site} prefetch={false}>
            <a
              className={styles.link}
              onClick={() => //console.log("before change")}
            >
              <div className={styles.linkTitle}>
                <span>
                  <Monitor />
                </span>
                نسخهٔ تلویزیون هوشمند
              </div>
            </a>
          </Link>
        </div> */}
        {/* <div className={styles.listItem}>
          <Link href={ROUTES.inviteFriends} prefetch={false}>
            <a
              className={styles.link}
              onClick={() => //console.log("before change")}
            >
              <div className={styles.linkTitle}>
                <span>
                  <Wifi />
                </span>
                دعوت از دوستان
              </div>

              <div className={styles.linkDescription}>۱۵۰ سکه</div>
            </a>
          </Link>
        </div> */}
        {/* <div className={styles.listItem}>
          <Link href={ROUTES.download} prefetch={false}>
            <a
              className={styles.link}
              onClick={() => //console.log("before change")}
            >
              <div className={styles.linkTitle}>
                <span>
                  <DownloadApp />
                </span>
                دانلود اپلیکیشن
              </div>
            </a>
          </Link>
        </div> */}
        <div className={styles.listItem}>
          <div className={styles.link} onClick={() => setShowExitPopup(true)}>
            <div className={styles.linkTitle}>
              <span>
                <LogOut />
              </span>
              خروج از حساب
            </div>
          </div>
          {showExitPopup && (
            <AppExitProfile onClose={() => setShowExitPopup(false)} />
          )}
        </div>
      </div>
    </div>
  );
};
